import { Transaction } from 'types/transaction'

export const getTransactionData = (transaction: Transaction): Record<string, any> => {
  try {
    const metadataString = transaction?.context?.depositDetails?.metadata
    return metadataString ? JSON.parse(metadataString) : {}
  } catch {
    return {}
  }
}

export const getIsRefundable = (transaction: Transaction): boolean => {
  const metadata = getTransactionData(transaction)
  return metadata?.refundable === true
}

export const getIsPartiallyRefundable = (transaction: Transaction): boolean => {
  const metadata = getTransactionData(transaction)
  return metadata?.supportsPartialRefunds === true
}

export const getMaximumRefundAmount = (transaction: Transaction): number => {
  const metadata = getTransactionData(transaction)
  return metadata?.amountAvailableToRefund
}
